import {Component, HostListener, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HotelService} from '../../core/services/hotel.service';

@Component({
  selector: 'app-busca-hoteis',
  templateUrl: './busca-hoteis.component.html',
  styleUrls: ['./busca-hoteis.component.sass']
})
export class BuscaHoteisComponent implements OnInit {

  public filteredBrands: any[];
  public brand: any;
  public innerWidth: any;
  isMobile = false;
  @Input()
  placeholder: string;
  @Input()
  size = 30;
  @Input()
  fontSize = '1rem';


  constructor( public hotelService: HotelService, private router: Router) {}

  ngOnInit() {
    this.handleMobile();
    this.setPlaceHolder();
  }

  setPlaceHolder() {
    if (!this.placeholder) {
      this.placeholder = (this.isMobile) ? 'Hotel, Estado ou Cidade.'  : 'Pesquise por Hotel, Estado, Cidade ou Bairro.';
      if (this.isMobile && this.innerWidth <= 320) {
        this.placeholder = 'Buscar';
      }
      return;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleMobile();
  }

  async filterBrands(event) {
    const resultData = await this.hotelService.buscaHoteisAutoComplete(event.query.toLowerCase());
    this.filteredBrands = [];

    resultData.data.paises.forEach(element => {
      this.filteredBrands.push({ tipo: 'paises', data: element });
    });

    resultData.data.estados.forEach(element => {
      this.filteredBrands.push({ tipo: 'estados', data: element });
    });

    resultData.data.cidades.forEach(element => {
      this.filteredBrands.push({ tipo: 'cidades', data: element });
    });

    resultData.data.bairros.forEach(element => {
      this.filteredBrands.push({ tipo: 'bairros', data: element });
    });

    resultData.data.hoteis.forEach(element => {
      this.filteredBrands.push({ tipo: 'hoteis', data: element });
    });

  }

  async selectInAutoComplete() {

    if (this.brand.tipo === 'hoteis') {
      await this.router.navigate(['/hoteis/hotel/', this.brand.data.id + '_' + this.brand.data.slug]);
      window.location.reload();
    } else if (this.brand.tipo === 'cidades') {
      localStorage.setItem('autocomplete', JSON.stringify(true));
      localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
      await this.router.navigate(['/busca-hoteis'], { queryParams: { codCidade: this.brand.data.id } });
      window.location.reload();
      location.reload();
    } else if (this.brand.tipo === 'estados') {
      localStorage.setItem('autocomplete', JSON.stringify(true));
      localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
      await this.router.navigate(['/busca-hoteis'], { queryParams: { codEstado: this.brand.data.id } });
      window.location.reload();
      location.reload();
    } else if (this.brand.tipo === 'paises') {
      localStorage.setItem('autocomplete', JSON.stringify(true));
      localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
      await this.router.navigate(['/busca-hoteis'], { queryParams: { codPais: this.brand.data.id } });
      window.location.reload();
      location.reload();
    } else if (this.brand.tipo === 'bairros') {
      localStorage.setItem('autocomplete', JSON.stringify(true));
      localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
      await this.router.navigate(['/busca-hoteis'], { queryParams: { codBairro: this.brand.data.nome } });
      window.location.reload();
      location.reload();
    }
  }

  getDetalheAutoComplete(autocomplete) {
    let detalhe = '';
    if (autocomplete.tipo === 'estados') {
      detalhe = autocomplete.data.pais;
    } else if (autocomplete.tipo === 'cidades') {
      detalhe = autocomplete.data.codEstado;
    } else if (autocomplete.tipo === 'bairros') {
      detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
    } else if (autocomplete.tipo === 'hoteis') {
      if (autocomplete.data.internacional === true) {
        detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.pais;
      } else {
        detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
      }
    }
    return detalhe;
  }

  getNomeAutoComplete(autocomplete) {
    let detalhe = '';
    if (autocomplete.tipo === 'estados') {
      detalhe = autocomplete.data.nome + ' (UF)';
    } else {
      detalhe = autocomplete.data.nome;
    }
    return detalhe;
  }

  getQuantidadeHoteis(autocomplete) {
    let quantidade = '';
    if (autocomplete.tipo !== 'hotéis ') {
      if (autocomplete.data.quantidade > 1) {
        quantidade = autocomplete.data.quantidade + ' hotéis ';
      } else {
        quantidade = autocomplete.data.quantidade + ' hotel';
      }
    }

    return quantidade;
  }

  private handleMobile() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1026) {
      this.isMobile = true;
      return;
    }
    this.isMobile = false;
  }
}
